export enum ContactHealthStatus {
    HEALTHY = 'healthy',
    ATTENTION = 'attention',
    AT_RISK = 'atRisk',
}
